import { createContext } from 'react';

export default createContext({
  dodone: null,
  startDodone: null,
  finishDodone: null,
  updateDodone: null,
  notification: null,
  onTick: null
});
